"use strict";
function identity(x) {
    return x;
}
exports.identity = identity;
//# sourceMappingURL=identity.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3048926480/src/~/rxjs/util/identity.js
// module id = Yuqz
// module chunks = 6